import "./landing-page-accordion.component.scss";

export default {
    template: require('./landing-page-accordion.component.html'),
    transclude: true,
    controller: function () {
        'ngInject';
    }
};
